import React from 'react';
import PropTypes from 'prop-types';
import { connectInfiniteHits } from 'react-instantsearch-dom';

import ResultListHits from '../ResultListHits/ResultListHits';

// Component Styles
import './resultList.scss';
/**
 * Filter and Find the style details based on style ids
 * @param {Object} hits       The font data object provided by Algolia.
 * @param {Object} styleList  StyleList provided by prediction server.
 * @return {Array}             Style data
 */
function matchingHits(hits, styleList) {
  const styleDataCollection = [];
  const listOfStyles = [];
  const sortedStyleCollection = [];

  // add foundry name on each included_fonts array
  for (let i = 0; i < hits.length; i++) {
    for (let j = 0; j < hits[i].included_fonts.length; j++) {
      hits[i].included_fonts[j].foundry_name = hits[i].foundry_name;
    }
    listOfStyles.push(hits[i].included_fonts);
  }

  // find the matching fonts on included_fonts and flatten them
  listOfStyles.forEach((styleDetails) => {
    styleDataCollection.push(...styleDetails.filter(style => styleList.includes(style.myfonts_style_id)));
  });

  // Sort fonts data based on styleList data
  for (let i = 0; i < styleList.length; i++) {
    for (let j = 0; j < styleDataCollection.length; j++) {
      if (styleList[i] === styleDataCollection[j].myfonts_style_id) {
        sortedStyleCollection.push(styleDataCollection[j]);
        break;
      }
    }
  }
  return sortedStyleCollection;
}

/**
 * This component shows the result list.
 */
function CustomInfiniteHits(props) {
  const {
    fontPreviewText, predictionText, imageHeight, imageSize, startOnPage,
    onPageChange, hits, styleList,
  } = props;
  const predictedStyleList = matchingHits(hits, styleList);
  if (predictedStyleList) {
    return (
      <div className='wtfResultList'>
        <ResultListHits
          predictedList={predictedStyleList}
          fontPreviewText={fontPreviewText}
          predictionText={predictionText}
          imageSize={imageSize}
          imageHeight={imageHeight}
          startOnPage={startOnPage}
          onPageChange={onPageChange}
        />
      </div>
    );
  }
}

/**
 * Set the CustomInfiniteHits component props default values.
 * @type {Object}
 * @property {Array}  styleList         list of style ids.
 * @property {String} fontPreviewText   font preview text value that the image will render. If `predictionText` prop
 *                                      is provided, this is ignored.
 * @property {String} predictionTextKey prediction encrypted text key that the image will render.
 * @property {String} imageSize         This is the size the image will render.
 * @property {String} imageHeight       It will change the height of the image already rendered in order to create a
 *                                      fast user experience in the font resizing.
 * @property {Number} resultsPerPage    The number of results shown per page when using pagination.
 * @property {Number} startOnPage       The number of the page that should be shown at startup.
 * @property {Function}
 * onPageChange    Callback to expose the number of page shown on the Result List
 */
CustomInfiniteHits.defaultProps = {
  styleList: [],
  fontPreviewText: '',
  predictionText: '',
  imageSize: '',
  imageHeight: '',
  startOnPage: 1,
  onPageChange: () => {},
};

/**
 * Declare the CustomInfiniteHits component PropTypes for better validation.
 * @type {Object}
 */
CustomInfiniteHits.propTypes = {
  styleList: PropTypes.arrayOf(PropTypes.string),
  fontPreviewText: PropTypes.string,
  predictionText: PropTypes.string,
  imageSize: PropTypes.string,
  imageHeight: PropTypes.string,
  startOnPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

const ResultList = connectInfiniteHits(CustomInfiniteHits);
export default ResultList;



// WEBPACK FOOTER //
// ./src/components/Result/ResultList/ResultList.js